import React, { type FC } from 'react'
import { Box, Icon, Typography } from 'shared/ui'

type ICellInboxProps = {
  name: string
  number?: string | null
}
export const CellInbox: FC<ICellInboxProps> = ({ name, number }) => {
  return (
    <Box display={'flex'} alignItems={'center'} gap={'6px'}>
      <Typography
        variant={'body-md-regular'}
        color={'var(--content-primary-primary)'}
        ellipsis
        tooltipProps={{ label: name }}
        ariaLabel={'name'}
      >
        {name}
      </Typography>
      {number && (
        <>
          <Icon icon={'ellipse_6'} fontSize={2} color={'var(--content-neutral-primary)'} />
          <Typography
            variant={'body-md-regular'}
            color={'var(--content-primary-tertiary)'}
            ellipsis
            tooltipProps={{ label: number }}
            ariaLabel={'number'}
          >
            {number}
          </Typography>
        </>
      )}
    </Box>
  )
}
